import styled from 'styled-components'

export const StyledWhyWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`
export const StyledWhyTitle = styled.h1`
    font-weight: bold;
    text-transform: uppercase;
    flex: 0 0 100%;
    text-align: center;
    margin: 5% 0;
    font-size: 3em;
`